import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const OutcomeShape = ({ width = 45, height = 45, style }: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 1024 1024"
    className="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M512 512m-480 0a480 480 0 1 0 960 0 480 480 0 1 0-960 0Z"
      fill="#FEE8EB"
    />
    <path
      d="M640 275.2c19.2 0 38.4 19.2 38.4 44.8v384c0 25.6-19.2 44.8-38.4 44.8H288c-19.2 0-38.4-19.2-38.4-44.8V320c0-25.6 19.2-44.8 38.4-44.8H640"
      fill="#FF8888"
    />
    <path
      d="M774.4 384v332.8c0 19.2-19.2 38.4-44.8 38.4H294.4c-25.6 0-44.8-19.2-44.8-38.4V345.6h480c25.6 0 44.8 12.8 44.8 38.4z"
      fill="#FF6B6A"
    />
    <path
      d="M684.8 480c-38.4 0-70.4 32-70.4 70.4s32 70.4 70.4 70.4h89.6V480h-89.6z m0 89.6c-12.8 0-25.6-12.8-25.6-25.6s12.8-25.6 25.6-25.6 25.6 12.8 25.6 25.6-12.8 25.6-25.6 25.6z"
      fill="#FFFFFF"
    />
  </svg>
);

export default OutcomeShape;
